<template>
  <nav></nav>
  <router-view />
</template>

<style>
#app {
  font-family: Sora, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fontVariant1 {
  font-size: 11px !important;
  font-weight: 500 !important;
}
.fontVariant2 {
  font-size: 17px !important;
  font-weight: 300 !important;
}
.fontVariant3 {
  font-size: 22px !important;
  font-weight: 300 !important;
}
.fontVariant4 {
  font-size: 14px !important;
  font-weight: 400 !important;
}
.fontVariant5 {
  font-size: 12px !important;
  font-weight: 800 !important;
}
.alertFont {
  font-size: 13px !important;
  font-weight: 500 !important;
}
.toolbar_color {
  background: #0e172a !important;
}
.v-tab {
  color: black !important;
  transition: all 0.3s ease !important;
}
.v-tab--selected {
  color: #db4c77 !important;
  background-color: var(--v-primary-base) !important;
}
.icon-color {
  background: linear-gradient(to right, #0f559a, #db4c77) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.button_color {
  background: #0e172a !important;
}
.button_animate {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.button_animate:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
.TableClass {
  overflow-x: hidden !important;
  border-radius: 8px !important;
}
.TableClass table th {
  height: 40px !important;
  background: #0f559a !important;
  color: white !important;
  font-size: 12px !important;
}
.TableClass .v-data-footer {
  min-height: 40px !important;
}
.TableClass .v-data-footer__pagination {
  font-size: 0.85rem !important;
}

/* Teams list — header navy (#0E172A) to match login / landing slate */
.teams-table.TableClass table th,
.teams-table.TableClass .v-table__wrapper > table > thead > tr > th {
  background: #0e172a !important;
  color: #f8fafc !important;
}

.teams-table.TableClass .v-data-table-header__sort-icon {
  color: rgba(248, 250, 252, 0.8) !important;
  opacity: 1 !important;
}

.teams-toolbar-btn {
  background: #0e172a !important;
  color: #f8fafc !important;
  box-shadow: none !important;
}

.teams-toolbar-btn:hover {
  background: #1e293b !important;
}

.teams-toolbar-btn .v-icon {
  color: #f8fafc !important;
}

.teams-row-icon-edit {
  color: #0e172a !important;
}

.teams-row-icon-delete {
  color: #b91c1c !important;
}

.teams-pagination .v-pagination__item--is-active .v-btn,
.teams-pagination .v-btn--active {
  background: #0e172a !important;
  color: #f8fafc !important;
}

/* Teams dialogs — toolbars + primary buttons (#0E172A) */
.teams-dialog-toolbar {
  background: #0e172a !important;
  color: #f8fafc !important;
}

.teams-dialog-toolbar .v-toolbar-title {
  color: #f8fafc !important;
}

.teams-dialog-toolbar .v-btn .v-icon {
  color: #f8fafc !important;
}

.teams-dialog-btn {
  background: #0e172a !important;
  color: #f8fafc !important;
}

.teams-dialog-btn:hover {
  background: #1e293b !important;
}

.teams-dialog-btn .v-btn__content {
  color: #f8fafc !important;
}

.teams-dialog-tabs .v-tab--selected {
  color: #0e172a !important;
}

.teams-dialog-tabs .v-tab__slider {
  background: #0e172a !important;
}

.teams-dialog-pagination .v-pagination__item--is-active .v-btn,
.teams-dialog-pagination .v-btn--active {
  background: #0e172a !important;
  color: #f8fafc !important;
}

.teams-dialog-icon-action {
  color: #0e172a !important;
}

.teams-dialog-btn-outline {
  color: #0e172a !important;
  border-color: rgba(14, 23, 42, 0.35) !important;
}

.teams-apps-status--on {
  color: #0e172a !important;
  font-weight: 600 !important;
}

.teams-apps-status--off {
  color: #64748b !important;
  font-weight: 600 !important;
}

.QuestionTableClass {
  overflow-x: hidden !important;
  border-radius: 8px !important;
}
.QuestionTableClass table th {
  height: 40px !important;
  background: #09335c !important;
  color: white !important;
  font-size: 12px !important;
}
.QuestionTableClass .v-data-footer {
  min-height: 40px !important;
}
.QuestionTableClass .v-data-footer__pagination {
  font-size: 0.85rem !important;
}
.time-toggle {
  background: #f3f4f6;
  border-radius: 10px;
  padding: 3px;
}
.time-toggle .v-btn {
  text-transform: none;
  font-weight: 600;
  color: #6b7280;
  background: transparent;
  transition: all 0.2s ease;
}
.time-toggle .v-btn.v-btn--active {
  background: #6366f1;
  color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.dbCardColour {
  background: #f1f1f1 !important;
}
.db_button_color {
  background: #6366f1 !important;
}
.page-loader {
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sticky-nav {
  position: sticky;
  top: 0;
  z-index: 1000;

  display: flex;
  gap: 10px;

  padding: 10px 16px;
  background: #eee;

  border-bottom: 1px solid #eee;
}
.sticky-nav .v-btn.active {
  background: linear-gradient(to right, #110a55, #0f559a) !important;
  color: white;
  border-radius: 999px;
  transition: all 0.25s ease;
}
.sticky-nav .v-btn {
  transition: all 0.2s ease;
}
.login-shell {
  min-height: 100vh;
  margin: 0;
  padding: clamp(1.25rem, 4vw, 2.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f4f2;
  background-image: radial-gradient(
    120% 80% at 50% 0%,
    rgba(15, 85, 154, 0.06),
    transparent 55%
  );
}

.login-frame {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
}

.login-panel {
  width: 100%;
  padding: clamp(2rem, 5vw, 2.75rem) clamp(1.5rem, 4vw, 2.25rem);
  background: transparent !important;
  border-radius: 20px;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  text-align: center;
}

.login-brand {
  display: flex;
  justify-content: center;
  margin-bottom: 1.75rem;
}

.login-logo {
  opacity: 0.92;
}

.login-window {
  overflow: visible;
}

.login-header {
  margin-bottom: 1.5rem;
}

.login-title {
  margin: 0;
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 1.375rem !important;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
  line-height: 1.25;
  white-space: normal;
}

.login-lede {
  margin: 0;
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.55;
  color: #64748b;
  opacity: 1 !important;
}

.login-email {
  display: block;
  margin: 0;
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #0f172a;
  word-break: break-all;
  line-height: 1.4;
  opacity: 1 !important;
}

.login-form {
  text-align: left;
}

.login-field .v-field {
  border-radius: 12px;
  font-size: 0.9375rem;
}

.login-field .v-field__outline {
  --v-field-border-opacity: 0.14;
}

.login-submit {
  font-family: Sora, Helvetica, Arial, sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.9375rem !important;
  letter-spacing: 0.01em;
  text-transform: none !important;
  background: #0f172a !important;
  color: #f8fafc !important;
  box-shadow: none !important;
  transition: background 0.2s ease, transform 0.15s ease;
}

.login-submit:hover {
  background: #1e293b !important;
}

.login-submit:active {
  transform: scale(0.99);
}

.login-otp {
  justify-content: center;
}

.login-otp .v-otp-input__field {
  border-radius: 10px;
  font-weight: 600;
  font-size: 1.125rem;
  text-align: center;
}

.login-otp .v-field {
  border-radius: 12px;
}

.login-otp .v-field__outline {
  --v-field-border-opacity: 0.14;
}

.login-resend {
  margin-top: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25rem 0.5rem;
  min-height: 2rem;
}

.login-resend-hint {
  font-size: 0.8125rem;
  color: #94a3b8;
  font-family: Sora, Helvetica, Arial, sans-serif;
}

.login-resend-btn {
  font-family: Sora, Helvetica, Arial, sans-serif !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.01em;
  color: #0f559a !important;
}

.login-success {
  padding: 0.5rem 0 0.25rem;
}

.login-success-title {
  margin: 0;
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 1.25rem !important;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.02em;
  white-space: normal;
}

.login-success-sub {
  margin: 0;
  font-size: 0.875rem;
  color: #64748b;
  font-family: Sora, Helvetica, Arial, sans-serif;
  line-height: 1.5;
  opacity: 1 !important;
}

.login-footnote {
  margin: 0;
  font-size: 0.75rem;
  color: #94a3b8;
  font-family: Sora, Helvetica, Arial, sans-serif;
  letter-spacing: 0.02em;
  line-height: 1.4;
  opacity: 1 !important;
}

/* Dashboard — same shell + surfaces as login */
.dashboard-shell {
  min-height: 100vh;
  background-color: #f4f4f2;
  background-image: radial-gradient(
    120% 80% at 50% 0%,
    rgba(15, 85, 154, 0.06),
    transparent 55%
  );
}

.dashboard-page .sticky-nav {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  row-gap: 6px;
  padding: 7px 14px;
  min-height: 44px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.dashboard-page .sticky-nav .v-btn {
  color: #64748b !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.01em;
  min-width: 0 !important;
  height: 30px !important;
  min-height: 30px !important;
  padding: 0 11px !important;
  transition: background 0.2s ease, color 0.2s ease;
}

.dashboard-page .sticky-nav .v-btn.active {
  background: #0f172a !important;
  color: #f8fafc !important;
  border-radius: 999px !important;
}

.dashboard-sticky-hint {
  min-height: 30px;
}

.dashboard-nav-icon {
  color: #94a3b8 !important;
}

.dashboard-nav-hint {
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 12px !important;
  font-weight: 600;
  color: #64748b;
  line-height: 30px !important;
  opacity: 1 !important;
  white-space: nowrap;
}

.dashboard-section-icon {
  color: #0f559a !important;
  opacity: 0.9;
}

.dashboard-section-title {
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 1.25rem !important;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
  line-height: 1.25;
}

.dashboard-lede {
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #64748b;
}

.dashboard-caption {
  color: #94a3b8 !important;
}

.dashboard-chart-label {
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.dashboard-surface {
  background: #ffffff !important;
  border: 1px solid rgba(15, 23, 42, 0.06) !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04),
    0 16px 40px -12px rgba(15, 23, 42, 0.08) !important;
}

.dashboard-metric-tile {
  background: #fafafa !important;
  border: 1px solid rgba(15, 23, 42, 0.06) !important;
  box-shadow: none !important;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.dashboard-metric-tile--raised {
  box-shadow: 0 10px 28px -8px rgba(15, 23, 42, 0.12) !important;
  border-color: rgba(15, 23, 42, 0.1) !important;
}

.dashboard-metric-label {
  font-family: Sora, Helvetica, Arial, sans-serif !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
  opacity: 1 !important;
  white-space: normal !important;
}

.dashboard-metric-value {
  color: #0f172a !important;
  opacity: 1 !important;
}

.dashboard-field .v-field {
  border-radius: 12px;
}

.dashboard-field .v-field__outline {
  --v-field-border-opacity: 0.14;
}

.dashboard-filter-btn {
  background: #0f172a !important;
  color: #f8fafc !important;
}

.dashboard-filter-btn:hover {
  background: #1e293b !important;
}

.dashboard-page .TableClass table th {
  background: #0f172a !important;
  color: #f8fafc !important;
}

.dashboard-page .dashboard-tabs .v-tab {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.dashboard-page .dashboard-tabs .v-tab--selected {
  color: #0f172a !important;
}

.dashboard-time-toggle {
  background: #eef0f2 !important;
  border-radius: 12px;
  padding: 4px;
}

.dashboard-time-toggle .v-btn {
  text-transform: none;
  font-weight: 600;
  color: #64748b;
}

.dashboard-time-toggle .v-btn.v-btn--active {
  background: #0f172a !important;
  color: #f8fafc !important;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.dashboard-table thead th {
  font-family: Sora, Helvetica, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  background: #f8fafc !important;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06) !important;
}

.dashboard-table tbody td {
  font-family: Sora, Helvetica, Arial, sans-serif;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.dashboard-page .v-pagination .v-pagination__item--is-active .v-btn,
.dashboard-page .v-pagination .v-btn--active {
  background: #0f172a !important;
  color: #f8fafc !important;
}

/* Landing shell — same shell + surfaces as login */
.landing-app {
  background-color: #f4f4f2 !important;
  background-image: radial-gradient(
    120% 80% at 50% 0%,
    rgba(15, 85, 154, 0.06),
    transparent 55%
  ) !important;
}

.landing-drawer {
  border-right: 1px solid rgba(15, 23, 42, 0.06) !important;
  background: #ffffff !important;
}

.landing-drawer-brand {
  padding: 0.65rem 0.5rem 0.5rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.landing-drawer-logo {
  opacity: 0.92;
}

.landing-drawer-scroll {
  overflow-y: auto;
  height: calc(100vh - 86px);
  padding-top: 2px;
}

.landing-drawer-scroll::-webkit-scrollbar {
  width: 6px;
}

.landing-drawer-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(15, 23, 42, 0.12);
  border-radius: 4px;
}

.landing-nav-list .v-list-item {
  margin-bottom: 1px;
  padding-inline: 6px !important;
  min-height: 34px !important;
}

.landing-nav-list .v-list-item__prepend > .v-icon {
  margin-inline-end: 6px !important;
}

.landing-nav-item {
  min-height: 34px !important;
}

.landing-nav-item.landing-nav-item--active {
  background: rgba(15, 23, 42, 0.06) !important;
}

.landing-nav-title {
  font-family: Sora, Helvetica, Arial, sans-serif !important;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
  color: #64748b !important;
  opacity: 1 !important;
  line-height: 1.25 !important;
}

.landing-nav-item--active .landing-nav-title {
  color: #0f172a !important;
}

.landing-nav-icon {
  color: #94a3b8 !important;
  opacity: 1 !important;
}

.landing-nav-icon--active {
  color: #0f559a !important;
}

.landing-toolbar {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06) !important;
}

.landing-toolbar-email {
  font-family: Sora, Helvetica, Arial, sans-serif !important;
  font-size: 0.8125rem !important;
  font-weight: 500 !important;
  color: #64748b !important;
  line-height: 1.4 !important;
  max-width: min(280px, 40vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 1 !important;
}

.landing-logout-btn {
  color: #0f172a !important;
}

.landing-main {
  background: transparent !important;
}
</style>
